import axios from 'axios';

// Anonymous-only client: NO interceptors (would otherwise auto-redirect to
// /login on 401, which has no meaning for a public career page). Uses the
// app's base URL configured via REACT_APP_API_URL.
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5148',
  timeout: 30000,
});

export const getTenantHeader = (tenantSlug) =>
  publicApi.get(`/v1/career/${encodeURIComponent(tenantSlug)}`);

export const listJobs = (tenantSlug) =>
  publicApi.get(`/v1/career/${encodeURIComponent(tenantSlug)}/jobs`);

// SPEC F3 — ilan görüntülenme sayımı: sunucu yalnız `X-Career-View: 1` başlıklı
// GET'i sayar. Başlığı YALNIZ ilan detayının İLK yüklemesi gönderir (`countView`);
// eski slug yönlendirmesinin ardından gelen ikinci GET başlıksızdır → çift sayım yok.
export const CAREER_VIEW_HEADER = 'X-Career-View';

export const getJob = (tenantSlug, jobSlug, { countView = false } = {}) =>
  publicApi.get(
    `/v1/career/${encodeURIComponent(tenantSlug)}/jobs/${encodeURIComponent(jobSlug)}`,
    countView ? { headers: { [CAREER_VIEW_HEADER]: '1' } } : undefined,
  );

// Aydınlatma metni: data.text null ise standart yerelleştirilmiş metin gösterilir.
export const getConsentText = (tenantSlug) =>
  publicApi.get(`/v1/career/${encodeURIComponent(tenantSlug)}/consent`);

export const submitApplication = (tenantSlug, jobSlug, payload, resumeFile) => {
  const form = new FormData();
  form.append('payload', JSON.stringify(payload));
  if (resumeFile) form.append('resume', resumeFile);
  return publicApi.post(
    `/v1/career/${encodeURIComponent(tenantSlug)}/jobs/${encodeURIComponent(jobSlug)}/apply`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};
